import DriverAppReleases from "../../../views/DriverAppReleases";
import DriverAppReleasesActions from "../../../views/DriverAppReleasesActions";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const driverAppReleasesRoutes = [
  {
    menuName: MenuNames.DRIVER_APP_RELEASE,
    path: "/driver-app-releases",
    component: DriverAppReleases,
    exact: true,
  },
  {
    menuName: MenuNames.DRIVER_APP_RELEASE,
    path: "/driver-app-releases/actions",
    component: DriverAppReleasesActions,
    exact: true,
  },
];

export default driverAppReleasesRoutes;
